import React from 'react';
import { Instagram, Mail } from 'lucide-react';

const FOOTER_LINKS = [
  { href: '#collection', label: 'Collection' },
  { href: '#story',      label: 'Story' },
  { href: '#why',        label: 'Why Vael' },
  { href: '#shop',       label: 'Shop' },
  { href: '#contact',    label: 'Contact' },
];

const Footer = () => (
  <footer
    data-testid="footer"
    className="site-footer"
    style={{ background: 'var(--black)', borderTop: '1px solid rgba(201,169,110,0.08)' }}
  >
    <div style={{ maxWidth: '1100px', margin: '0 auto' }}>

      {/* Logo + tagline */}
      <div style={{ textAlign: 'center', marginBottom: '56px' }}>
        <div style={{ fontFamily: 'Tenor Sans', fontStyle: 'normal', fontSize: '11px', letterSpacing: '6px', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '8px' }}>
          MAISON
        </div>
        <div style={{ fontFamily: 'Cinzel', fontStyle: 'normal', fontSize: 'clamp(40px, 8vw, 72px)', letterSpacing: '12px', fontWeight: 400, color: 'var(--cream)', lineHeight: 1 }}>
          VAEL
        </div>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '16px', margin: '20px 0 16px' }}>
          <div style={{ width: '50px', height: '1px', background: 'rgba(201,169,110,0.2)' }} />
          <div style={{ width: '4px', height: '4px', background: 'var(--gold)', transform: 'rotate(45deg)', opacity: 0.7 }} />
          <div style={{ width: '50px', height: '1px', background: 'rgba(201,169,110,0.2)' }} />
        </div>
        <p style={{ fontFamily: 'Cormorant Garamond', fontStyle: 'italic', fontSize: '16px', color: 'var(--grey)', letterSpacing: '3px', marginBottom: '32px' }}>
          The Art of Inspired Fragrance
        </p>

        {/* Social / contact. Laid out in CSS, not inline styles, because it
            needs media queries: side by side these two need 479px and a phone
            gives ~294px, so on narrow screens they stack and the letter-spacing
            tightens. */}
        <div className="footer-social">
          <a
            href="https://instagram.com/maisonofvael"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="footer-social-link"
          >
            <Instagram size={14} strokeWidth={1.5} aria-hidden="true" />
            @maisonofvael
          </a>

          <div className="footer-social-divider" aria-hidden="true" />

          <a
            href="mailto:maisonofvael@gmail.com"
            data-testid="footer-email-link"
            className="footer-social-link"
          >
            <Mail size={14} strokeWidth={1.5} aria-hidden="true" />
            maisonofvael@gmail.com
          </a>
        </div>
      </div>

      {/* Nav links */}
      <nav aria-label="Footer" style={{ display: 'flex', justifyContent: 'center', gap: '48px', marginBottom: '48px', flexWrap: 'wrap' }}>
        {FOOTER_LINKS.map(({ href, label }) => (
          <a key={href} href={href} className="nav-link" style={{ fontSize: '11px' }}>{label}</a>
        ))}
      </nav>

      {/* Divider */}
      <div style={{ height: '1px', background: 'rgba(201,169,110,0.08)', marginBottom: '40px' }} />

      {/* Bottom row */}
      <div className="footer-bottom">
        <p style={{ fontFamily: 'Tenor Sans', fontStyle: 'normal', fontSize: '11px', letterSpacing: '2px', textTransform: 'uppercase', color: 'var(--grey-dim)' }}>
          © {new Date().getFullYear()} Maison Vael. Toronto, Ontario.
        </p>
        <p className="footer-disclaimer">
          All fragrances are original compositions inspired by designer scents. Not affiliated with any designer brand.
        </p>
      </div>

    </div>
  </footer>
);

export default Footer;
